import React from 'react';
import {
    Button
} from 'react-bootstrap';
import Swal from 'sweetalert2';
import Spinner from '../../../components/UI/Spinner/Spinner';
import Axios from 'axios';
import Configs from '../../../Configs';
import Parse from '../../../Parse';

class MoreOpenApiButton extends React.PureComponent {

    state = {
        openPopup: false,
        loading: false,
        params: {
            username: null,
            password: null
        },
        isEmpty: false
    };

    componentDidMount() {
       
    }

    updateServerConfig = () => {
        const params = {...this.state.params};
        this.setState({
            loading: true
        })
        Axios.post(`${Configs.openAPIUrl}/register`, {
            username: params.username,
            password: params.password
        }).then((response) => {
            console.log(response);
            if(response.data.status == "success") {
                Swal.fire({
                    title: 'Success!',
                    text: response.data.message,
                    icon: 'success',
                    confirmButtonText: 'OK'
                })
            } else {
                Swal.fire({
                    title: 'Error!',
                    text: response.data.message,
                    icon: 'error',
                    confirmButtonText: 'OK'
                })
            }
        }).catch((error) => {
            console.log(error);
            Swal.fire({
                title: 'Error!',
                text: 'Something went wrong',
                icon: 'error',
                confirmButtonText: 'OK'
            })
        }).finally(() => {
            this.setState({
                loading: false
            });
        });
    }

    closePopupHandler = () => {
        this.setState({
            openPopup: false,
        })
    }

    openPopupHandler = () => {
        this.setState({
            openPopup: true,
        })
    }

    inputChangeHandler = (val, key) => {
        const params = {...this.state.params};
        this.setState({
            params: {
                ...params,
                [key]: val
            }
        })
    }

    render () {
        const params = {...this.state.params};
        return (
            <React.Fragment>
                <Button variant="success pull-right" onClick={() => this.openPopupHandler()}>
                    <i className="fa fa-cog"></i>
                    <span className="hidden-xs hidden-sm">&nbsp;OpenAPI</span>
                </Button>
                {
                    this.state.openPopup ? (
                        <div className="MoreButtonPopup">
                            <div className="popup_image_bover">
                            </div>
                            <div className="popup_image form-popup">
                                <div className="form-container">
                                    <div className="popup_header">
                                        <h3 className="pull-left">OpenAPI</h3>
                                    </div>
                                    <div className="popup_body">
                                        {
                                            this.state.loading ? (
                                                <Spinner></Spinner>
                                            ) : (
                                                <div className="col-md-12 col-xs-12 col-lg-12">
                                                    <div className={`form-group ${ params.username == undefined || params.username == "" ? `has-error` : ""}`}>
                                                        <label>Username</label>
                                                        <input type="text" className="form-control" value={params.username !== undefined ? params.username : ""} onChange={(e) => {
                                                            this.inputChangeHandler(e.target.value, "username");
                                                        }} />
                                                        {
                                                            params.username == undefined || params.username == "" ? (
                                                                <span className="help-block">{`No Username`}</span>
                                                            ) : null
                                                        }
                                                    </div>
                                                    <div className={`form-group ${ params.password == undefined || params.password == "" ? `has-error` : ""}`}>
                                                        <label>Password</label>
                                                        <input type="text" className="form-control" value={params.password !== undefined ? params.password : ""} onChange={(e) => {
                                                            this.inputChangeHandler(e.target.value, "password");
                                                        }} />
                                                        {
                                                            params.password == undefined || params.password == "" ? (
                                                                <span className="help-block">{`No Password`}</span>
                                                            ) : null
                                                        }
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </div>
                                    <div className="popup_footer">
                                        <div className="row">
                                            <div className="col-xs-6 col-md-6 col-lg-6 buttonFooter">
                                                <button className="btn btn-primary btn-block" onClick={this.updateServerConfig}>Save</button>
                                            </div>
                                            <div className="col-xs-6 col-md-6 col-lg-6 buttonFooter">
                                                <button className="btn btn-default btn-block" onClick={this.closePopupHandler}>Cancel</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : null
                }
            </React.Fragment>
        )
    }
}

export default MoreOpenApiButton;